export const PERMISSION = {
  ADD: 'MD_EXPERIENCE_ADD',
  EDIT: 'MD_EXPERIENCE_EDIT',
  VIEW: 'MD_EXPERIENCE_VIEW',
  DEL: 'MD_EXPERIENCE_DEL',
};
